import { AlertTriangle } from "lucide-react";

export const StatiCruscotto = ({ stats, stati, label, badge, active, ritardo, onPick }) => (
  <div className="mb-8" data-testid="sin-stati-cruscotto">
    <div className="text-[11px] uppercase tracking-wide text-slate-400 mb-2">Sinistri per stato</div>
    <div className="flex flex-wrap gap-2">
      <button onClick={() => onPick("all", false)} data-testid="sin-stato-tile-all"
        className={`rounded-lg border px-3 py-2 text-left transition-colors ${active === "all" && !ritardo ? "border-navy bg-navy text-white" : "border-slate-200 bg-white hover:border-slate-400"}`}>
        <div className="text-[11px] opacity-70">Tutti</div><div className="font-heading text-lg leading-tight">{stats.totale}</div>
      </button>
      {stati.map((st) => {
        const n = stats.per_stato?.[st] || 0;
        const r = stats.ritardo_per_stato?.[st] || 0;
        const on = active === st;
        return (
          <div key={st} className={`rounded-lg border bg-white transition-colors ${on ? "border-slate-800 ring-1 ring-slate-800" : "border-slate-200 hover:border-slate-400"} ${n === 0 ? "opacity-60" : ""}`}>
            <button onClick={() => onPick(st, false)} className="px-3 pt-2 pb-1 text-left block" data-testid={`sin-stato-tile-${st}`}>
              <span className={`text-[11px] px-1.5 py-0.5 rounded-full ${badge[st]}`}>{label[st]}</span>
              <div className="font-heading text-lg leading-tight mt-1 text-slate-900">{n}</div>
            </button>
            {r > 0 && (
              <button onClick={() => onPick(st, true)} data-testid={`sin-stato-ritardo-${st}`}
                className={`w-full text-left px-3 pb-2 text-[11px] flex items-center gap-1 ${active === st && ritardo ? "text-red-700 font-semibold" : "text-red-600 hover:underline"}`}>
                <AlertTriangle className="h-3 w-3" /> {r} oltre {stats.soglie?.[st]}g
              </button>
            )}
          </div>
        );
      })}
    </div>
  </div>
);
